// extracted by mini-css-extract-plugin
export default {"thumbnails":"thumbnails-ada1","thumbnail":"thumbnail-7637","more":"more-a8a7","hasLink":"hasLink-7cb5","text":"text-d3b3"};